import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .hasName()
    .hasSummary()
    .hasThumbnail()
    .publishable()
    .publishableByDate()
    .hasTimestamps()
    .make();

export default schema;
